import axios from 'axios';
import makeApi from './api';

// eslint-disable-next-line require-jsdoc
function getApiUrl(host) {
  host = host || window.location.host;
  const prtcl = window.location.protocol;
  const i = host.indexOf('.commandcentral.com');
  if (i > -1) {
    const segments = host.substr(0, i).split('.');
    return `${prtcl}//${segments[0]}-api${segments.length > 1 ? '.' + segments[1] : ''}.commandcentral.com`;
  } else if ( host == 'cieinternalportalprod.azureedge.net') {
    return 'https://cieportal-api.commandcentral.com';
  } else {
    return `${prtcl}//localhost:8081`;
  }
}

const client = axios.create({
  baseURL: getApiUrl(),
  json: true,
});

const api = makeApi(client);

export default api;


